import { AppQuery_user as IUser } from 'main/framework/__generated__/AppQuery'

import { identify } from './identify'
import reset from './reset'
import waitForAnalytics from './wait'

declare var window: any

export { default as track } from './track'

export default function identifyOrReset(user: IUser | null): void {
  waitForAnalytics(() => {
    if (user) {
      identify(user)
    } else if (window.analytics.user().id()) {
      reset()
    }
  })
}
